export default __webpack_public_path__ + "img/jtc/jtc6_480.webp";